function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Button, ControlLabel } from 'react-bootstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SignaturePad from 'react-signature-pad';

import './Signature.css';

var Signature = function (_Component) {
  _inherits(Signature, _Component);

  function Signature() {
    var _temp, _this, _ret;

    _classCallCheck(this, Signature);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleAccept = function () {
      var sig = _this.refs.signature;
      if (!sig.isEmpty()) {
        _this.context.form.set(_this.props.name, sig.toDataURL());
      }
    }, _this.handleClear = function () {
      _this.refs.signature.clear();
    }, _this.handleEdit = function () {
      _this.context.form.set(_this.props.name, '');
    }, _this.render = function () {
      var value = _this.context.form.get(_this.props.name);
      var buttonSize = _this.props.buttonSize;

      var img = React.createElement(
        'div',
        { className: 'Signature-Components' },
        React.createElement(
          'div',
          { className: 'Signature-Image' },
          React.createElement('img', { alt: 'signature', src: value })
        ),
        React.createElement(
          'div',
          { className: 'Signature-Buttons' },
          React.createElement(
            Button,
            { bsSize: buttonSize, bsStyle: 'warning',
              onClick: _this.handleEdit },
            'Edit'
          )
        )
      );

      var sig = React.createElement(
        'div',
        { className: 'Signature-Components' },
        React.createElement(
          'div',
          { className: 'Signature-Canvas' },
          React.createElement(SignaturePad, { maxWidth: 2.5, minWidth: 1.5, ref: 'signature' })
        ),
        React.createElement(
          'div',
          { className: 'Signature-Buttons' },
          React.createElement(
            Button,
            { bsSize: buttonSize, bsStyle: 'success',
              onClick: _this.handleAccept },
            'Accept'
          ),
          React.createElement(
            'span',
            { className: 'Signature-Space' },
            React.createElement(
              Button,
              { bsSize: buttonSize, bsStyle: 'danger',
                onClick: _this.handleClear },
              'Clear'
            )
          )
        )
      );

      var classNames = 'Signature';
      if (_this.props.fixedRatio) {
        classNames += ' Signature-Fixed';
      }

      return React.createElement(
        'div',
        { className: classNames },
        _this.props.label && React.createElement(
          ControlLabel,
          null,
          _this.props.label
        ),
        React.createElement(
          'p',
          null,
          'Draw your signature in the box below and then hit \'Accept\''
        ),
        value ? img : sig
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Signature;
}(Component);

Signature.contextTypes = {
  form: PropTypes.object.isRequired
};

Signature.defaultProps = {
  buttonSize: 'large',
  fixedRatio: true
};

Signature.propTypes = process.env.NODE_ENV !== "production" ? {
  buttonSize: PropTypes.string,
  fixedRatio: PropTypes.bool.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired
} : {};

export default Signature;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Signature.js
// module id = 715
// module chunks = 0